module.exports = {
  endpoint: process.env.NODE_ENV === 'production' ? 'https://api.z-boom.ru' : 'http://localhost:820'
};
